import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=69d62e23"
import script from "./Static.vue?vue&type=script&lang=js"
export * from "./Static.vue?vue&type=script&lang=js"
import style0 from "./Static.vue?vue&type=style&index=0&id=69d62e23&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports